<template>
  <div
    v-if="show"
    class="error-default__wrapper"
  >
    <div class="error-default__container">
      <div class="error-default__title">
        Erro no carregamento
      </div>
      <div class="error-default__description">
        Houve uma falha no carregamento dos dados. Por favor, tente novamente.
      </div>
      <DsButton
        color="secondary"
        size="dense"
        @click="$emit('onClickButton')"
      >
        Tente Novamente
      </DsButton>
    </div>
  </div>
</template>

<script>
import { DsButton } from '@ds/components';
export default {
  components: {
    DsButton,
  },
  props: {
    show: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.error-default {
  &__wrapper {
    position: relative;
    height: 330px;
  }

  &__container {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: -50%;
    transform: translate(-50%, -50%);
  }

  &__title {
    text-align: center;
    color: var(--ds-color-text-1);
    font-weight: var(--ds-font-weight-semibold);
    margin-bottom: var(--ds-spacing-stack-nano);
  }

  &__description {
    text-align: center;
    color: var(--ds-color-text-2);
    margin-bottom: var(--ds-spacing-stack-xs);
  }

  &__button {
    text-align: center;
    color: var(--ds-color-text-2);
    margin-bottom: var(--ds-spacing-stack-md);
  }
}
</style>
